import { render, staticRenderFns } from "./AnnouncementItemsEditorComponent.vue?vue&type=template&id=3375fb86&scoped=true&"
import script from "./AnnouncementItemsEditorComponent.vue?vue&type=script&lang=js&"
export * from "./AnnouncementItemsEditorComponent.vue?vue&type=script&lang=js&"
import style0 from "./AnnouncementItemsEditorComponent.vue?vue&type=style&index=0&id=3375fb86&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3375fb86",
  null
  
)

export default component.exports